import type { ButtonProps } from "@qws-org/ui-kit";
import { Button, Flex } from "@qws-org/ui-kit";
import type { FC, ReactNode } from "react";

import type { Action, Pages } from "~/core";
import type { GetPageLayoutQuery } from "~/core/sdk";
import {
  isExternalLink,
  isInternalLink,
  isTemplateUrl,
} from "~/core/utils/action.utils";

export type TopHeaderButtonProps = {
  item: NonNullable<
    ExtractArrayItemType<
      NonNullable<
        NonNullable<
          NonNullable<GetPageLayoutQuery["header"]>["top_additional_menu"]
        >["action_items"]
      >
    >
  >["menu_action_items_id"];
  getUrl: (page: Pages) => string;
  onCallAction: (action: Action) => void;
  icon?: ReactNode;
} & ButtonProps<"button">;

export const TopHeaderButton: FC<TopHeaderButtonProps> = ({
  item,
  getUrl,
  onCallAction,
  icon,
  ...props
}) => {
  const currentAction = item?.action;
  const action = currentAction?.action?.[0];
  let href: string | undefined;

  if (isExternalLink(action?.item)) {
    if (isTemplateUrl(action?.item)) {
      href = undefined;
    } else {
      href = action.item.href ?? undefined;
    }
  }
  if (isInternalLink(action?.item)) {
    href = action.item.page ? getUrl(action.item.page) : undefined;
  }

  return (
    <Button
      {...props}
      m={{ my: 16 }}
      md={{
        m: { my: 16 },

        display: item?.action?.inactive_if?.includes("isMobile")
          ? "block"
          : item?.action?.inactive_if?.includes("isDesktop")
            ? "hidden"
            : undefined,
      }}
      d={{ m: { my: 16 } }}
      href={href}
      display={
        item?.action?.inactive_if?.includes("isMobile")
          ? "hidden"
          : item?.action?.inactive_if?.includes("isDesktop")
            ? "block"
            : undefined
      }
      width="100%"
      className={`${props.className ?? ""} whitespace-nowrap`}
      variant="tertiary"
      onPress={() => {
        if (currentAction) {
          onCallAction(currentAction);
        }
      }}
      data-testid="header-top-button"
    >
      <Flex as="span" minWidth="max-content">
        {icon && icon}
        {item?.translations?.[0]?.name}
      </Flex>
    </Button>
  );
};
